import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

import { useOnboardingState } from '@/contexts/OnboardingContext';

/** Route ``/onboarding/stripe/cancel`` — terminal landing page when the
 * user clicks "Back" inside Stripe Checkout. The onboarding state has
 * not advanced (no webhook fired), so the timeline still shows
 * ``stripe_checkout`` as the current step. We stamp
 * ``stripeOutcome='cancelled'`` so the section's banner explains why
 * we're back at the picker.
 */
export function StripeCancelPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setStripeOutcome } = useOnboardingState();
  // React 18 StrictMode double-effect guard.
  const dispatchedRef = useRef(false);

  useEffect(() => {
    if (dispatchedRef.current) return;
    dispatchedRef.current = true;
    setStripeOutcome({ kind: 'cancelled' });
    navigate('/bot', { replace: true });
  }, [navigate, setStripeOutcome]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-3 text-sm text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" aria-hidden="true" />
        <p>{t('onboarding.stripe.cancelled.redirecting')}</p>
      </div>
    </div>
  );
}
